export default __webpack_public_path__ + "static/media/gallery_08.519fc03f.jpg";